import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import { greeting } from "../../portfolio.js";

export default function Footer(props) {
  return (
    <footer
      className="route-footer"
      style={{
        "--footer-text": props.theme.text,
        "--footer-muted": props.theme.secondaryText,
        "--footer-accent": props.theme.imageHighlight,
      }}
    >
      <div className="route-footer-inner">
        <Link className="route-footer-brand" to="/home">
          <span>SG</span>
          <b>SETHURAM GAUTHAM</b>
        </Link>
        <p>Available for AI/ML engineering roles · {greeting.title}</p>
        <div className="route-footer-actions">
          <a
            className="route-footer-resume"
            href={greeting.resumeLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a>
          <Link className="route-footer-contact" to="/contact">
            Let&apos;s talk <span>→</span>
          </Link>
          <button
            type="button"
            className="route-footer-toggle"
            onClick={props.onToggle}
            aria-label="Toggle theme"
          >
            {props.isDark ? "PAPER" : "NIGHT"}
          </button>
        </div>
      </div>
    </footer>
  );
}
